export const MATCH_DROPDOWN_WINDOW_MS = 4 * 60 * 60 * 1000;

export type MatchWindowItem = {
  id: string;
  startsAt: string;
};

export function selectableMatches<T extends MatchWindowItem>(matches: T[], nowMs: number): T[] {
  return matches
    .filter((match) => new Date(match.startsAt).getTime() + MATCH_DROPDOWN_WINDOW_MS > nowMs)
    .sort((left, right) => left.startsAt.localeCompare(right.startsAt));
}